import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

//const url = "http://fbi.tizdata.com:22222/api/rest"
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 60000
})

service.interceptors.request.use(
    config => {
        if (store.getters.token) {
            //config.headers['X-Token'] = getToken()
            config.headers.Authorization = `token ${getToken()}`
        }
        return config
    },
    error => {
        console.log(error)
        return Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    return res
  },
  error => {
    let msg = ""
    
    if(error.response){
      if(error.response.status == 401){
        store.dispatch('user/resetToken').then(() => {
          location.replace("/#/login");
        })
      }else{
        msg = error.response.data.message
      }
    }
    console.log('err' + error) // for debug
    Message({
      message: msg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service




// WEBPACK FOOTER //
// ./src/utils/request.js